<template>
  <div class="gallery_wrap">
    <div class="header flex z-20 absolute left-0 top-0 w-full justify-between">
      <div class="ml-4 mt-4 w-10">
        <router-link :to="{ name: 'Gallery' }">
          <img
            class="icon"
            src="../../../assets/images/gallery/person.png"
            alt="내 가상전시관 보기"
          />
        </router-link>
      </div>
      <div class="mt-2 w-16">
        <img class="logo" src="../../../assets/images/logo.png" alt="로고" />
      </div>
      <div class="m-4">
        <button @click="onBack()">
          <img
            src="../../../assets/images/close_btn.png"
            alt="닫기"
            class="w-6 m-auto"
          />
        </button>
      </div>
    </div>
    <!-- <div class="bg_wall"></div> -->
    <!-- 5개 유물 배치-->
    <gallery-display-scroll
      :items="galleryRelics"
      :myGallery="false"
    ></gallery-display-scroll>
    <!-- <gallery-display
      :items="galleryRelics"
      :myGallery="false"
    ></gallery-display> -->
  </div>
</template>

<script>
import GalleryDisplayScroll from "../../../components/GalleryDisplayScroll.vue";
import { API_URL, SERVICE_API_URL } from "../../../common/config";
import services from "../../../services";
export default {
  components: { GalleryDisplayScroll },
  name: "GalleryId",
  data() {
    return {
      galleryId: 0,
      galleryRelics: [],
      API_URL: "",
      SERVICE_API_URL: "",
    };
  },
  created() {
    this.fetch();
    console.log(this.$route.params.usersId);
    this.API_URL = API_URL;
    this.SERVICE_API_URL = SERVICE_API_URL;
    console.log(API_URL);
  },
  methods: {
    onBack() {
      if ( window.history.length > 1 ) {
        this.$router.go(-1);
      } else {
        this.$router.push("/");
      }
    },
    async fetch() {
      this.galleryId = this.$route.params.galleryId;
      await services.galleryFindOne(this.galleryId).then(
        () => {
          this.findGalleryRelic();
        },
        (error) => {
          const { data } = error.response;
          console.log(data);
        }
      );
    },
    findGalleryRelic() {
      services
        .galleryRelicFindByGalleryId({ galleriesId: this.galleryId, size:1000 })
        .then(
          (response) => {
            const { data } = response;
            this.galleryRelics[0] = data.items.find((item) => item.number == 1);
            this.galleryRelics[1] = data.items.find((item) => item.number == 2);
            this.galleryRelics[2] = data.items.find((item) => item.number == 3);
            this.galleryRelics[3] = data.items.find((item) => item.number == 4);
            this.galleryRelics[4] = data.items.find((item) => item.number == 5);
            this.galleryRelics[5] = data.items.find((item) => item.number == 6);
            this.galleryRelics[6] = data.items.find((item) => item.number == 7);
            this.galleryRelics[7] = data.items.find((item) => item.number == 8);
            this.galleryRelics[8] = data.items.find((item) => item.number == 9);
            this.galleryRelics[9] = data.items.find(
              (item) => item.number == 10
            );
            this.galleryRelics[10] = data.items.find(
              (item) => item.number == 11
            );
            this.galleryRelics[11] = data.items.find(
              (item) => item.number == 12
            );

            console.log(this.galleryRelics);
            const parseString = require("xml2js").parseString;
            this.galleryRelics.forEach((item) => {
              if (item) {
                parseString(item.usersRelics.relics.name, (error, result) => {
                  if (result.lang) {
                    switch (this.$i18n.locale) {
                      case "ko":
                        item.usersRelics.relics.name = result.lang.ko[0];
                        break;
                      case "en":
                        item.usersRelics.relics.name = result.lang.en[0];
                        break;
                      case "child":
                        item.usersRelics.relics.name = result.lang.ko[0];
                        break;
                      case "zh":
                        item.usersRelics.relics.name = result.lang.zh[0];
                        break;
                      case "ja":
                        item.usersRelics.relics.name = result.lang.ja[0];
                        break;
                      default:
                        item.usersRelics.relics.name = result.lang.ko[0];
                    }
                    if (!item.usersRelics.relics.name) {
                      item.usersRelics.relics.name = result.lang.ko[0];
                    }
                  } else if (error) {
                    console.log(error);
                  }
                });

                parseString(
                  item.usersRelics.relics.essential,
                  (error, result) => {
                    if (result.lang) {
                      switch (this.$i18n.locale) {
                        case "ko":
                          item.usersRelics.relics.essential = result.lang.ko[0];
                          break;
                        case "en":
                          item.usersRelics.relics.essential = result.lang.en[0];
                          break;
                        case "child":
                          item.usersRelics.relics.essential =
                            result.lang.ko[0];
                          break;
                        case "zh":
                          item.usersRelics.relics.essential = result.lang.zh[0];
                          break;
                        case "ja":
                          item.usersRelics.relics.essential = result.lang.ja[0];
                          break;
                        default:
                          item.usersRelics.relics.essential = result.lang.ko[0];
                      }
                      if (!item.usersRelics.relics.essential) {
                        item.usersRelics.relics.essential = result.lang.ko[0];
                      }
                    } else if (error) {
                      console.log(error);
                    }
                  }
                );
              }
            });
          },
          (error) => {
            const { data } = error.response;
            console.log(data);
          }
        );
    },
  },
};
</script>

<style scoped>
.icon {
  max-height: 40px;
}
.header div img {
  filter: drop-shadow(1px 1px 1px #333);
}
.gallery_wrap {
  width: 100%;
  height: 100%;
  overflow-y: hidden;
}
#display_test {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.bg_wall {
  height: 100%;
  margin-top: 10px;
  /* background: url("../../../assets/images/gallery/gallery_wall.png") no-repeat
    center; */
  filter: blur(3px);
}
</style>
